module.exports = __webpack_public_path__ + "static/media/garbageTruck_purple.a3b0b4a8.svg";